export default "__VITE_ASSET__1f238d9a__"